import { Injectable } from '@angular/core'
import { MatDialog, MatDialogConfig } from '@angular/material/dialog'
import {
  GenericExportDialogComponent,
  GenericExportDialogConfig,
} from '@tv3/shared/dialogs/generic-export-dialog/generic-export-dialog.component'
import { formatDate, User } from '@tokeet-frontend/tv3-platform'
import * as moment from 'moment'

@Injectable()
export class DownloadUserSettingsDialogService {
  constructor(private dialog: MatDialog) {}

  private getConfig(data: User[]): GenericExportDialogConfig {
    return {
      title: $localize`Download User Settings to CSV`,
      description: $localize`You are about to download all user settings within your current filter.`,
      columns: [
        { name: $localize`Name`, field: 'name' },
        { name: $localize`Created`, field: (t: User) => formatDate(t.created, 'date', false) },
        { name: $localize`Role`, field: 'roleView' },
        { name: $localize`Email`, field: 'email' },
        { name: $localize`Phone`, field: 'phone' },
        { name: $localize`Country`, field: 'countryView' },
        { name: $localize`Last Login`, field: (t: User) => formatDate(t.lastLogin, 'datetime', false) },
      ],
      exportData: data,
      filename: $localize`Users` + ` - ${moment().format('MM_DD_YYYY')}`,
      columnCustomizable: true,
    }
  }

  open(users: User[]) {
    const defaultConfig: MatDialogConfig = {
      width: '650px',
      height: 'auto',
      panelClass: ['variable-modal'],
      data: {
        config: this.getConfig(users),
      },
    }

    return this.dialog.open(GenericExportDialogComponent, defaultConfig)
  }
}
